import cx from 'classnames';

import { Destination } from '../../../resources/destination/domain/types/destination';
import { DestinationsMenuTopDestination } from '../../../resources/destinationsMenu/domain/types/destinationsMenu';
import { PickDomain } from '../../../shared/utilities/types/PickDomain';

import { FooterBrand } from './FooterBrand/FooterBrand';
import { FooterLogo } from './FooterCopyright/FooterLogo';
import { FooterLinks } from './FooterLinks/FooterLinks';
import { FooterNewsletter } from './FooterNewsletter/FooterNewsletter';
import { FooterLogoGrid } from './FooterPartners/FooterLogoGrid';

import style from './Footer.module.css';

export const FOOTER_NEWSLETTER_ID = 'footer-newsletter';

type Props = {
    destination?: PickDomain<Destination, 'slug'>;
    noBrand?: true;
    obfuscateBrandLinks?: boolean;
    obfuscateNewsletterLinks?: boolean;
    topDestinations: Array<DestinationsMenuTopDestination>;
};

export function Footer({
    destination,
    noBrand,
    obfuscateBrandLinks: obfuscateFooterBrandLinks,
    obfuscateNewsletterLinks,
    topDestinations,
}: Props) {
    return (
        <>
            {!noBrand ? (
                <div className={style.brand}>
                    <FooterBrand obfuscateLinks={obfuscateFooterBrandLinks} />
                </div>
            ) : null}
            <div id={FOOTER_NEWSLETTER_ID} className={style.newsletter}>
                <div className={style.newsletterWrapper}>
                    <FooterNewsletter
                        destination={destination}
                        obfuscateLinks={obfuscateNewsletterLinks}
                    />
                </div>
            </div>
            <div className={cx('layout-with-centered-content', style.footer)}>
                <div className={cx(style.footerLinks, 'main-container')}>
                    <FooterLinks topDestinations={topDestinations} />
                </div>
                <div className={cx(style.footerLogoGrid, 'main-container')}>
                    <FooterLogoGrid />
                </div>
                <div className="main-container">
                    <FooterLogo />
                </div>
            </div>
        </>
    );
}
